"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USERINFO = exports.SESSION = exports.EnumLoadingType = void 0;
var _loginString = require("./loginString");
var USERINFO = exports.USERINFO = 'user_info';
var SESSION = exports.SESSION = 'SESSION';
var EnumLoadingType = exports.EnumLoadingType = {
  juslink: _loginString.juslinkLodingHtml,
  hidden: " ",
  normal: _loginString.commonLoadingHtml
};